import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomSwitcher = props => (
  <Header {...props}>
    <span>Grant</span>&nbsp;Rowland M.D.
  </Header>
);

export default CustomSwitcher;
